import React from 'react'
import ReactDOM from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import App from './App.tsx'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'

// HappyCo theme configuration matching brand standards
const theme = {
  primaryColor: 'blue',
  fontFamily: '"proxima-nova", "Proxima Nova", sans-serif',
  headings: {
    fontFamily: '"proxima-nova", "Proxima Nova", sans-serif'
  },
  colors: {
    // HappyCo brand colors - Mantine requires tuples of exactly 10 colors
    brand: ['#EFEFFF', '#E0DEFF', '#D0CEFF', '#C1BDFF', '#B1ACFF', '#A292FF', '#9281FF', '#8271FF', '#7260FF', '#635BFF'] as const,
    navy: ['#f0f1f6', '#d9dce8', '#c2c7da', '#abb3cc', '#949ebe', '#7d89b0', '#6674a2', '#4f5f94', '#384a86', '#232A5C'] as const,
    success: ['#e6fbf7', '#b3f2e6', '#80e8d4', '#4ddfc3', '#1ad5b1', '#00C389', '#00a674', '#008a60', '#006d4b', '#005137'] as const,
    error: ['#fde8e8', '#f8b8b8', '#f38888', '#ee5858', '#e92828', '#E91E1F', '#c41a1b', '#9f1617', '#7a1113', '#550c0f'] as const
  },
  spacing: {
    xs: '8px',
    sm: '12px', 
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px'
  },
  components: {
    Button: {
      styles: () => ({
        root: {
          minHeight: '48px',
          fontFamily: '"proxima-nova", "Proxima Nova", sans-serif'
        }
      })
    },
    Card: {
      styles: () => ({
        root: {
          borderRadius: '8px'
        }
      })
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications position="bottom-left" />
      <App />
    </MantineProvider>
  </React.StrictMode>,
)